import {saveCredentials}  from "../reducers/SaveUserCredentials";

export const addUserDetails = (items) => (dispatch) => {
    dispatch(saveCredentials(items));
  };